import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HitExcursions } from '../../../../../interfaces/src/lib/types/index';

type SelectedExcursionsCard = HitExcursions | null;

export interface ExcursionsCardState {
  selectedEscursionsCard: SelectedExcursionsCard;
  isLayerExcursionsOpen: boolean;
}

const initialState: ExcursionsCardState = {
  selectedEscursionsCard: null,
  isLayerExcursionsOpen: false,
};

const escursionsCardSlice = createSlice({
  name: 'escursionsCard',
  initialState,
  reducers: {
    setSelectedExcursionsCard: (state, action: PayloadAction<SelectedExcursionsCard>) => {
      state.selectedEscursionsCard = action.payload;
    },
    setIsLayerExcursionsOpen: (state, action: PayloadAction<boolean>) => {
      state.isLayerExcursionsOpen = action.payload;
    },
  },
});

export const { setSelectedExcursionsCard, setIsLayerExcursionsOpen } = escursionsCardSlice.actions;
export default escursionsCardSlice.reducer;
